import { BackupPolicyType } from '@repo/api-gw-sdk';

import { Tag } from '@/components/tag';

import { isPitrPolicyType, isStandardPolicyType } from './backupPoliciesTypes';

export const BackupPolicyTypeTag = ({
  policyType = BackupPolicyType.BACKUP_POLICY_TYPE_STANDARD,
}: {
  policyType?: BackupPolicyType;
}) => {
  if (policyType === BackupPolicyType.BACKUP_POLICY_TYPE_UNSPECIFIED) {
    return null;
  }

  const content = isPitrPolicyType(policyType)
    ? 'PiTR'
    : policyType === BackupPolicyType.BACKUP_POLICY_TYPE_HIGH_FREQUENCY
      ? 'High-frequency'
      : isStandardPolicyType(policyType)
        ? 'Standard'
        : 'Unknown';

  return content && <Tag noWrap content={content} variant='secondary' />;
};
